/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_ErrorInputs */

const en_admin_settings_test_error = /** @type {(inputs: Admin_Settings_Test_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test failed`)
};

const zh_admin_settings_test_error = /** @type {(inputs: Admin_Settings_Test_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试失败`)
};

/**
* | output |
* | --- |
* | "Test failed" |
*
* @param {Admin_Settings_Test_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_error = /** @type {((inputs?: Admin_Settings_Test_ErrorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_ErrorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_test_error(inputs)
	return zh_admin_settings_test_error(inputs)
});
export { admin_settings_test_error as "admin.settings.test.error" }